import { render } from "./CourseSections.vue?vue&type=template&id=23f99e03"
import script from "./CourseSections.vue?vue&type=script&lang=js"
export * from "./CourseSections.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__